import { inject, Injectable } from '@angular/core';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { ActiveToast, GlobalConfig, IndividualConfig, ToastContainerDirective, ToastNoAnimation, ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class VoltaToastrService {

    //TODO: If i try to extend ToastrService instead of injecting, any closed toasts stay in DOM and just be invisible.
    //      Its better to extend for future proofing instead of having to create all methods reflecting the ones in the Service.
    private toastrService = inject(ToastrService);

    BASE_OPTIONS: Partial<IndividualConfig<any>> = {
        toastComponent: ToastComponent,
        toastClass: 'ngx-toastr bg--navy-600 color--white-100'
    }

    clear(toastId?: number): void {
        return this.toastrService.clear(toastId);
    }

    get currentlyActive() {
        return this.toastrService.currentlyActive;
    }
    set currentlyActive(currentlyActive:number){
        this.toastrService.currentlyActive = currentlyActive;
    }

    error<ConfigPayload = unknown>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<unknown> {
        return this.toastrService.error<ConfigPayload>(
            message, 
            title,
            {
                ...this.BASE_OPTIONS,
                ...override
            }
        );
    }

    findDuplicate(title: string, message: string, resetOnDuplicate: boolean, countDuplicates: boolean): ActiveToast<unknown> {
        return this.toastrService.findDuplicate(title, message, resetOnDuplicate, countDuplicates);
    }

    info<ConfigPayload = unknown>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<unknown> {
        return this.toastrService.info<ConfigPayload>(
            message, 
            title,
            {
                ...this.BASE_OPTIONS,
                ...override
            }
        );
    }

    get overlayContainer() {
        return this.toastrService.overlayContainer;
    }
    set overlayContainer(overlayContainer:ToastContainerDirective|undefined){
        this.toastrService.overlayContainer = overlayContainer;
    }

    get previousToastMessage() {
        return this.toastrService.previousToastMessage;
    }
    set previousToastMessage(previousToastMessage:string|undefined){
        this.toastrService.previousToastMessage = previousToastMessage;
    }

    remove(toastId: number): boolean {
        return this.toastrService.remove(toastId);
    }

    show<C extends ToastNoAnimation = ToastNoAnimation<unknown>, ConfigPayload = unknown>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>, type?: string): ActiveToast<C> | null {
        return this.toastrService.show<C, ConfigPayload>(
            message, 
            title,
            {
                ...this.BASE_OPTIONS,
                ...override
            },
            type
        );
    }

    success<ConfigPayload = unknown>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<unknown> {
        return this.toastrService.success<ConfigPayload>(
            message, 
            title,
            {
                ...this.BASE_OPTIONS,
                ...override
            }
        );
    }

    get toastrConfig() {
        return this.toastrService.toastrConfig;
    }
    set toastrConfig(toastrConfig:GlobalConfig<unknown>){
        this.toastrService.toastrConfig = toastrConfig;
    }

    get toasts() {
        return this.toastrService.toasts;
    }
    set toasts(toasts:ActiveToast<unknown>[]){
        this.toastrService.toasts = toasts;
    }
  
    warning<ConfigPayload = unknown>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<unknown> {
        return this.toastrService.warning<ConfigPayload>(
            message, 
            title,
            {
                ...this.BASE_OPTIONS,
                ...override
            }
        );
    }
}
